import React, {useState, useEffect} from "react"
import {Routes, Route} from "react-router-dom"
import Snowfall from 'react-snowfall'

import Work from "../work/Work"
import Home from "../home/Home"
import NotFound from "../notfound/NotFound"

import AWS1 from "../../assets/images/cert-img/0.png";
import AWS2 from "../../assets/images/cert-img/1.png";
import AWS3 from "../../assets/images/cert-img/2.png";
import AWS4 from "../../assets/images/cert-img/4.png";
import AZU5 from "../../assets/images/cert-img/5.png";
import LIN6 from "../../assets/images/cert-img/6.png";
import CIW from "../../assets/images/cert-img/3.png";

import "./Mainview.css"

export default function Mainview() {

const API_URL = "https://1kdmj78958.execute-api.us-east-1.amazonaws.com/development";
const certData = {
    AZU5: { src: AZU5, alt: "azure fundamentals" },
    AWS1: { src: AWS1, alt: "cloud practitioner" },
    AWS2: { src: AWS2, alt: "solutions architect associate" },
    AWS3: { src: AWS3, alt: "cloud essentials badge" },
    AWS4: { src: AWS4, alt: "developer associate" },
    LIN6: { src: LIN6, alt: "linux essentials" },
    CIW: { src: CIW, alt: "ciw advanced html5 & css3 specialist" },

};

const [data, setData] = useState([]);
const [loading, setLoading] = useState(true);
const [error, setError] = useState(null);

useEffect(() => {
// You can perform side effects here if needed when data, loading, or error changes

async function fetchData() {
    setLoading(true);
    setError(null);
    try {
    const res = await fetch(API_URL);
    if (!res.ok) throw new Error(`Request failed with status ${res.status}`);
    const json = await res.json();
    // adapt this line if the API returns a different shape
    setData(JSON.parse(json.body).data);
    } catch (err) {
    if (err.name !== "AbortError") setError(err);
    } finally {
    setLoading(false);
    }
}

fetchData();

}, []);


    return (
        <div className="mainview">
            <Snowfall
                // Changes the snowflake color
                color="white"
                // Controls the number of snowflakes that are created (default 150)
                snowflakeCount={200}
                // Applied to the canvas element
                style={{
                position: 'fixed',
                width: '100vw',
                height: '100vh',
                zIndex: 2,
                }}
            />
            <Routes>
                <Route path="/" element={<Home data={data} loading={loading} error={error} certData={certData} />} />
                <Route path="/work" element={<Work/>} />
                <Route path="*" element={<NotFound />} />                
            </Routes>
            
        </div>
    );
}